import { adjustAccordingToTimezone, extractQueryParamsToArray, getDateForIntervalFilter } from '../../../utils/common';
import { ALL_OPTION_ID, HISTORICAL_EVENT_FIELD_NAME, HISTORICAL_EVENT_QUERY_PARAMS_NAME } from '../constants';

// eslint-disable-next-line jsdoc/require-jsdoc
export function formatFilterValueToQueryParamsFormat(value, timezone) {
  const formattedFilter = [
    [HISTORICAL_EVENT_QUERY_PARAMS_NAME.MATCH_ID, value[HISTORICAL_EVENT_FIELD_NAME.MATCH_ID]],
    [HISTORICAL_EVENT_QUERY_PARAMS_NAME.FILTER_SHOW,
      value[HISTORICAL_EVENT_FIELD_NAME.FILTER_SHOW] !== ALL_OPTION_ID
        ? value[HISTORICAL_EVENT_FIELD_NAME.FILTER_SHOW]
        : null],
    // eslint-disable-next-line max-len
    [HISTORICAL_EVENT_QUERY_PARAMS_NAME.TEAMS_NAME, value[HISTORICAL_EVENT_FIELD_NAME.TEAMS_NAME]],
  ];

  if (value[HISTORICAL_EVENT_FIELD_NAME.LEAGUES].length) {
    value[HISTORICAL_EVENT_FIELD_NAME.LEAGUES].forEach((leagueId) => {
      formattedFilter.push([HISTORICAL_EVENT_QUERY_PARAMS_NAME.LEAGUES, leagueId]);
    });
  }

  if (
    value[HISTORICAL_EVENT_FIELD_NAME.DATE_FILTER]?.from
    && value[HISTORICAL_EVENT_FIELD_NAME.DATE_FILTER]?.to) {
    formattedFilter.push(
      [HISTORICAL_EVENT_QUERY_PARAMS_NAME.START_DATE,
        adjustAccordingToTimezone(
          timezone, value[HISTORICAL_EVENT_FIELD_NAME.DATE_FILTER].from,
        )],
    );
    formattedFilter.push(
      [HISTORICAL_EVENT_QUERY_PARAMS_NAME.END_DATE,
        adjustAccordingToTimezone(
          timezone, value[HISTORICAL_EVENT_FIELD_NAME.DATE_FILTER].to,
        )],
    );
  }

  return formattedFilter;
}

// eslint-disable-next-line jsdoc/require-jsdoc
export function constructFilterFromQueryParams(queryParamsString, filterValue) {
  const extractedQueryParams = extractQueryParamsToArray(queryParamsString);
  const newFilterValue = { ...filterValue };

  extractedQueryParams.forEach((query) => {
    const [key, value] = query;

    switch (key) {
      case HISTORICAL_EVENT_QUERY_PARAMS_NAME.START_DATE:
        newFilterValue[HISTORICAL_EVENT_FIELD_NAME.DATE_FILTER]
          .from = getDateForIntervalFilter(new Date(value));
        break;

      case HISTORICAL_EVENT_QUERY_PARAMS_NAME.END_DATE:
        newFilterValue[HISTORICAL_EVENT_FIELD_NAME.DATE_FILTER]
          .to = getDateForIntervalFilter(new Date(value));
        break;

      case HISTORICAL_EVENT_QUERY_PARAMS_NAME.FILTER_SHOW:
        newFilterValue[HISTORICAL_EVENT_FIELD_NAME.FILTER_SHOW] = parseInt(value);
        break;

      case HISTORICAL_EVENT_QUERY_PARAMS_NAME.LEAGUES:
        newFilterValue[HISTORICAL_EVENT_FIELD_NAME.LEAGUES].push(parseInt(value));
        break;

      default:
        newFilterValue[key] = value;
        break;
    }
  });
  return newFilterValue;
}
